/**
 * Where the last press happened, so an overlay can grow from the control that
 * opened it (library, Foundations / Motion: everything "travels from where it
 * came from"). One capture listener for the whole app; it records only the
 * point and the time, nothing about the target.
 */
let last: { x: number; y: number; at: number } | null = null;

if (typeof window !== "undefined") {
  window.addEventListener(
    "pointerdown",
    (event) => {
      last = { x: event.clientX, y: event.clientY, at: performance.now() };
    },
    { capture: true, passive: true },
  );
}

/** The last press, if it was recent enough to have opened what is opening now. */
export function recentPointer(withinMs = 1200): { x: number; y: number } | null {
  if (!last || performance.now() - last.at > withinMs) return null;
  return { x: last.x, y: last.y };
}
